import { render, staticRenderFns } from "./AddEditSection.vue?vue&type=template&id=066078d7"
import script from "./AddEditSection.vue?vue&type=script&lang=js"
export * from "./AddEditSection.vue?vue&type=script&lang=js"
import style0 from "./AddEditSection.vue?vue&type=style&index=0&id=066078d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports